import { Column } from 'devextreme-react/data-grid';
import PackIcon from './PackIcon';
import CustomCell from './devExpressTable/CustomCell';
import CustomDataGrid from './devExpressTable/CustomDataGrid';
import CustomImageCell from './devExpressTable/CustomImageCell';
import TableButtonsAction from './devExpressTable/TableButtonsAction';

const columns = ['objectId', 'image', 'name', 'description'];

// A row flagged `virtual` (« Sans pack ») only has the preview button.
const OverlayDataGrid = ({ onFormatData, onEdit, onDelete, onChange, onMove, onPreview, onRowClick, FilterText }) => {
  const handleEdit = (id) => {
    onEdit(id);
  };
  const handleDelete = (id) => {
    onDelete(id);
  };
  const handleMove = (id, up) => {
    onMove(id, up);
  };
  const handleOptionChange = (e) => {
    onChange(e);
  };

  return (
    <CustomDataGrid
      actionColumnWidth={onPreview ? 200 : 150}
      reloadDataPagination={onFormatData}
      showColumnLines={false}
      defaultText={FilterText}
      onRowClick={onRowClick ? ({ data, event }) => data && !event?.target?.closest?.('[data-zoom]') && onRowClick(data.objectId) : undefined}
      actionRender={(value) => {
        const virtual = !!value.data.virtual;
        return (
          <TableButtonsAction
            onPreview={onPreview ? () => onPreview(value.data.objectId) : undefined}
            previewIcon={`${process.env.PUBLIC_URL}/eye.svg`}
            onEdit={virtual ? undefined : () => handleEdit(value.data.objectId)}
            onDelete={virtual ? undefined : () => handleDelete(value.data.objectId)}
            onMove={virtual ? undefined : (up) => handleMove(value.data.objectId, up)}
            label={value.data.name}
          />
        );
      }}
      onOptionChanged={handleOptionChange}
    >
      <Column dataField={columns[1]} caption="Image" alignment="center" cellRender={({ data }) => <CustomImageCell value={data.image} label={data.name} />} />
      <Column
        dataField={columns[2]}
        caption="Name"
        alignment="center"
        cellRender={({ data }) => (
          <CustomCell
            value={
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <PackIcon name={data.icon} />
                {data.name}
              </span>
            }
            alignment="center"
          />
        )}
      />
      <Column
        dataField={columns[3]}
        caption="Description"
        alignment="center"
        cellRender={({ data }) => <CustomCell value={data.description} alignment="center" />}
      />
    </CustomDataGrid>
  );
};

export default OverlayDataGrid;
